// Sentry wird NICHT mehr im Hauptbundle mitgeliefert (~420 KB unkomprimiert), sondern
// erst nachgeladen, wenn die Seite fertig aufgebaut ist. Fehler, die vorher auftreten,
// werden gesammelt und nach dem Laden nachgereicht. Komplett inaktiv ohne
// REACT_APP_SENTRY_DSN (dann wird auch nichts nachgeladen).

const DSN = process.env.REACT_APP_SENTRY_DSN;

let sentry = null;          // geladenes @sentry/react-Modul
const pending = [];         // Fehler vor dem Laden
const readyListeners = [];  // Callbacks, die das geladene Modul brauchen (z. B. Feedback-Button)

function queueGlobalError(e) {
  if (!sentry) pending.push(e.error || e.reason || e.message);
}

export function initSentryLazy() {
  if (!DSN || typeof window === "undefined") return;

  // Bis Sentry da ist: globale Fehler selbst mitschreiben
  window.addEventListener("error", queueGlobalError);
  window.addEventListener("unhandledrejection", queueGlobalError);

  const load = () =>
    import("@sentry/react").then((S) => {
      S.init({
        dsn: DSN,
        environment: process.env.NODE_ENV,
        // Hobby-Projekt, geringes Traffic-Volumen → niedrige Sample-Rate reicht,
        // spart Sentry-Quota (Performance-Tracing, nicht Error-Tracking).
        tracesSampleRate: 0.1,
        // autoInject: false → kein generischer Floating-Button im Sentry-Standarddesign.
        // Footer.js hängt den Trigger per feedback.attachTo() an den eigenen
        // "Report a Bug"-Button (über onSentryReady).
        integrations: [S.feedbackIntegration({ autoInject: false, colorScheme: "system" })],
      });
      sentry = S;
      window.removeEventListener("error", queueGlobalError);
      window.removeEventListener("unhandledrejection", queueGlobalError);
      pending.splice(0).filter(Boolean).forEach((err) => S.captureException(err));
      readyListeners.splice(0).forEach((cb) => cb(S));
    }).catch(() => { /* Sentry nicht ladbar (Adblocker o. ä.) → App läuft normal weiter */ });

  // Nach dem Laden der Seite im Leerlauf – blockiert weder Hero-Bild noch ersten Render
  const whenIdle = () => (window.requestIdleCallback ? window.requestIdleCallback(load, { timeout: 4000 }) : setTimeout(load, 1500));
  if (document.readyState === "complete") whenIdle();
  else window.addEventListener("load", whenIdle, { once: true });
}

export function captureException(error) {
  if (!DSN) return;
  if (sentry) sentry.captureException(error);
  else pending.push(error);
}

// Callback, sobald Sentry geladen ist (sofort, falls schon geladen). Liefert eine
// Abmeldefunktion für useEffect-Cleanups.
export function onSentryReady(cb) {
  if (!DSN) return () => {};
  if (sentry) { cb(sentry); return () => {}; }
  readyListeners.push(cb);
  return () => {
    const i = readyListeners.indexOf(cb);
    if (i >= 0) readyListeners.splice(i, 1);
  };
}
